
export class CfCoreGalleryAnimation {
    static Fade = 'fade';
    static Slide = 'slide';
    static Rotate = 'rotate';
    static Zoom = 'zoom';
}

function CfCoreGalleryAnimation_tsickle_Closure_declarations() {
/** @type {?} */
CfCoreGalleryAnimation.Fade;
/** @type {?} */
CfCoreGalleryAnimation.Slide;
/** @type {?} */
CfCoreGalleryAnimation.Rotate;
/** @type {?} */
CfCoreGalleryAnimation.Zoom;
}

